module.exports = __webpack_public_path__ + "img/marker_one_cyan2.5befcaa8.png";